import request from '@/services/interceptor.js'

/**
 * POST /api/registrazione
 * Registra una nuova azienda (endpoint pubblico, senza auth).
 */
export const registra_azienda = (data) => {
    return request({
        url: '/registrazione',
        method: 'post',
        data,
        loadingBar: true
    })
}

/**
 * PUT /api/registrazione/admin/aziende/{id}/licenza
 * Aggiorna lo stato licenza di un'azienda.
 * @param {number} aziendaId
 * @param {number} licenzaStato  — 1=attiva, 0=attesa, -1=sospesa
 */
export const aggiorna_licenza = (aziendaId, licenzaStato) => {
    return request({
        url: `/registrazione/admin/aziende/${aziendaId}/licenza`,
        method: 'put',
        data: { licenzaStato },
        loadingBar: true
    })
}